import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQuerySummaryData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['summaryDataLine', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId),
        cacheTime: 0,
    });
};
